module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "u-form SessionForm",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "SessionForm-inner"
  }, [_c('h1', {
    staticClass: "SessionForm-headline u-mb4"
  }, [_vm._v("Sign Up")]), _vm._v(" "), (!!_vm.errorMessages.length) ? _c('div', {
    staticClass: "u-richtext u-richtext--scale"
  }, _vm._l((_vm.errorMessages), function(errorMessage, index) {
    return _c('p', {
      staticClass: "SessionForm-feedback u-mb2"
    }, [_vm._v("\n        " + _vm._s(errorMessage.message) + "\n      ")])
  })) : _vm._e(), _vm._v(" "), (!_vm.submitted) ? _c('div', [_c('div', {
    staticClass: "u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "user-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "user-name",
      "type": "text",
      "name": "user[name]"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "user-email",
      "type": "email",
      "name": "user[email]"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "user-organization"
    }
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "u-relative SignupForm-orgSearch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationId),
      expression: "organizationId"
    }],
    attrs: {
      "type": "hidden",
      "value": "user[organization_id]"
    },
    domProps: {
      "value": (_vm.organizationId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrganizationName),
      expression: "newOrganizationName"
    }],
    attrs: {
      "type": "hidden",
      "value": "new_org_name"
    },
    domProps: {
      "value": (_vm.newOrganizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newOrganizationName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.organizationQuery),
      expression: "organizationQuery",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "user-organization",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.organizationQuery)
    },
    on: {
      "keyup": _vm.setOrgs,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationQuery = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.showOrgMenu) ? _c('div', {
    staticClass: "SignupForm-organizations"
  }, [(!!_vm.organizations.length) ? _c('ul', _vm._l((_vm.organizations), function(organization, index) {
    return _c('li', {
      staticClass: "SignupForm-organizations-item"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectOrg(organization)
        }
      }
    }, [_vm._v(_vm._s(organization.name))])])
  })) : _vm._e(), _vm._v(" "), (!!_vm.organizationQuery) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createOrg($event)
      }
    }
  }, [_vm._v("\n              Create new organization \"" + _vm._s(_vm.organizationQuery) + "\"\n            ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.submitted) ? _c('div', [_c('p', [_vm._v("Thank you for signing up. You will be notified when your account has been approved.")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-form--actions u-mt4"
  }, [_c('button', {
    staticClass: "Button Button--square",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign Up")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6717ebc4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/signup-form.vue
// module id = 339
// module chunks = 0